var irreducible = require('./irreducible');
var isFunction = require('./isFunction');

module.exports = irreducible('Function', isFunction);



//////////////////
// WEBPACK FOOTER
// ../node_modules/tcomb/lib/Function.js
// module id = 226
// module chunks = 0